import FlagEN from '@/assets/images/flags/en.svg';
import FlagDE from '@/assets/images/flags/de.svg';
import FlagTH from '@/assets/images/flags/th.svg';
import FlagVI from '@/assets/images/flags/vn.svg';
import FlagES from '@/assets/images/flags/es.svg';
import FlagFR from '@/assets/images/flags/fr.svg';
import FlagAR from '@/assets/images/flags/ar.svg';
import FlagID from '@/assets/images/flags/id.svg';
import FlagHI from '@/assets/images/flags/hi.svg';
import FlagIT from '@/assets/images/flags/it.svg';
import FlagJP from '@/assets/images/flags/jp.svg';
import FlagNL from '@/assets/images/flags/nl.svg';
import FlagNO from '@/assets/images/flags/no.svg';
import FlagPL from '@/assets/images/flags/pl.svg';
import FlagPT from '@/assets/images/flags/pt.svg';
import FlagRU from '@/assets/images/flags/ru.svg';
import FlagSE from '@/assets/images/flags/se.svg';
import FlagTR from '@/assets/images/flags/tr.svg';
import FlagZH from '@/assets/images/flags/zh.svg';
import FlagUK from '@/assets/images/flags/ua.svg';
import FlagCS from '@/assets/images/flags/cs.svg';
import FlagRO from '@/assets/images/flags/ro.svg';
import FlagKO from '@/assets/images/flags/ko.svg';
import FlagFIL from '@/assets/images/flags/fil.svg';
import FlagFA from '@/assets/images/flags/ir.svg';

export type LangCodes =
  | 'de'
  | 'th'
  | 'vi'
  | 'en'
  | 'es'
  | 'fr'
  | 'ar'
  | 'id'
  | 'hi'
  | 'it'
  | 'ja'
  | 'nl'
  | 'no'
  | 'pl'
  | 'pt'
  | 'ru'
  | 'sv'
  | 'tr'
  | 'zh'
  | 'uk'
  | 'cs'
  | 'ro'
  | 'ko'
  | 'fil'
  | 'fa';

export interface ILanguage {
  iconId: string;
  value: string;
  label: string;
  iconLink: string;
}

type TRecord<K extends string> = {
  [P in K]: ILanguage;
};

export type LanguagesMap = Readonly<TRecord<LangCodes>>;

export const languagesMap: LanguagesMap = {
  en: {
    iconId: 'us',
    value: 'en',
    label: 'English',
    iconLink: FlagEN,
  },

  uk: {
    iconId: 'ua',
    value: 'uk',
    label: 'Українська',
    iconLink: FlagUK,
  },

  de: {
    iconId: 'de',
    value: 'de',
    label: 'Deutsch',
    iconLink: FlagDE,
  },

  th: {
    iconId: 'th',
    value: 'th',
    label: 'Thai',
    iconLink: FlagTH,
  },

  vi: {
    iconId: 'vi',
    value: 'vi',
    label: 'Vietnamese',
    iconLink: FlagVI,
  },

  es: {
    iconId: 'es',
    value: 'es',
    label: 'Español',
    iconLink: FlagES,
  },

  fr: {
    iconId: 'fr',
    value: 'fr',
    label: 'Français',
    iconLink: FlagFR,
  },

  ar: {
    iconId: 'ar',
    value: 'ar',
    label: 'ภาษาไทย',
    iconLink: FlagAR,
  },

  id: {
    iconId: 'id',
    value: 'id',
    label: 'Indonesian',
    iconLink: FlagID,
  },

  hi: {
    iconId: 'hi',
    value: 'hi',
    label: 'हिन्दी',
    iconLink: FlagHI,
  },

  it: {
    iconId: 'it',
    value: 'it',
    label: 'Italiano',
    iconLink: FlagIT,
  },

  ja: {
    iconId: 'jp',
    value: 'ja',
    label: 'はじめる',
    iconLink: FlagJP,
  },

  nl: {
    iconId: 'nl',
    value: 'nl',
    label: 'Nederlands',
    iconLink: FlagNL,
  },

  no: {
    iconId: 'no',
    value: 'no',
    label: 'Norsk',
    iconLink: FlagNO,
  },

  pl: {
    iconId: 'pl',
    value: 'pl',
    label: 'Polski',
    iconLink: FlagPL,
  },

  pt: {
    iconId: 'pt',
    value: 'pt',
    label: 'Português',
    iconLink: FlagPT,
  },

  ru: {
    iconId: 'ru',
    value: 'ru',
    label: 'Русский',
    iconLink: FlagRU,
  },

  sv: {
    iconId: 'se',
    value: 'sv',
    label: 'Svenska',
    iconLink: FlagSE,
  },

  tr: {
    iconId: 'tr',
    value: 'tr',
    label: 'Türkçe',
    iconLink: FlagTR,
  },

  zh: {
    iconId: 'zh',
    value: 'zh',
    label: '简体中文',
    iconLink: FlagZH,
  },

  cs: {
    iconId: 'cs',
    value: 'cs',
    label: 'Čeština',
    iconLink: FlagCS,
  },

  ro: {
    iconId: 'ro',
    value: 'ro',
    label: 'Romanesc',
    iconLink: FlagRO,
  },

  ko: {
    iconId: 'ko',
    value: 'ko',
    label: '한국인',
    iconLink: FlagKO,
  },

  fil: {
    iconId: 'fil',
    value: 'fil',
    label: 'Filipino',
    iconLink: FlagFIL,
  },

  fa: {
    iconId: 'fa',
    value: 'fa',
    label: 'فارسی',
    iconLink: FlagFA,
  },
};
